export default __webpack_public_path__ + "static/bg-02-f5f7597a1840596b61f2d08ad29f3c55.png";